import PropTypes from "prop-types";

const Thumbnail = ({ src }) => (
  <div className="tw-w-[120px] tw-h-[96px] tw-rounded-[4px] tw-overflow-hidden">
    <img
      className="tw-w-full tw-h-full tw-object-cover"
      src={`${src}&width=120&height=96&quality=80`}
      alt="Property Main"
    />
  </div>
);

export default Thumbnail;

Thumbnail.propTypes = {
  src: PropTypes.string.isRequired,
};
